import { TTabKeys } from '@routes/session-details/CourseSessionDetails';
import { Tab } from '@fe-learner-common/components/Tabs';
import { faPersonChalkboard } from '@fortawesome/pro-solid-svg-icons/faPersonChalkboard';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faAlignLeft } from '@fortawesome/pro-solid-svg-icons/faAlignLeft';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons/faCalendarRange';

export const tabMap: Record<TTabKeys, Tab> = {
  overview: {
    titleId: 'catalog.tab.overview.title',
    value: 'overview',
    icon: faAlignLeft,
  },
  participants: {
    titleId: 'catalog.tab.participants.title',
    value: 'participants',
    icon: faUser,
  },
  instructors: {
    titleId: 'catalog.tab.instructors.title',
    value: 'instructors',
    icon: faPersonChalkboard,
  },
  events: {
    titleId: 'catalog.tab.events.title',
    value: 'events',
    icon: faCalendarRange,
  },
};
